import Xarrow from "react-xarrows";
import { useCases } from "../../providers/Cases";

const CaseArrows = () => {
  const { actualCases } = useCases();

  return (
    <div>
      {actualCases.map((item, index) => {
        return (
          <Xarrow
            key={index}
            zIndex={-1}
            start={`case${item.id}`}
            end={`heart`}
            showHead={false}
            strokeWidth={1}
            color={"var(--secondaryBgColor)"}
            curveness={0.5}
            endAnchor={"middle"}
            startAnchor={"middle"}
          />
        );
      })}
    </div>
  );
};

export default CaseArrows;
